import PropTypes from "prop-types";

export const templatePropTypes = {
    onBlockMount: PropTypes.func.isRequired,
    onNewsClick: PropTypes.func.isRequired,
    onTeaserClick: PropTypes.func.isRequired,
    onInternalClick: PropTypes.func.isRequired,
    onCategoryClick: PropTypes.func.isRequired,
    onRecommendationClick: PropTypes.func.isRequired,

    loading: PropTypes.bool.isRequired,

    data: PropTypes.object.isRequired,
    scrollData: PropTypes.array.isRequired,
    lastLoadTeasers: PropTypes.array,

    news: PropTypes.object.isRequired,
    nextNews: PropTypes.object,
    categories: PropTypes.array.isRequired,

    currency: PropTypes.object,

    geoCity: PropTypes.string
};

export const DEVICE = {
    mobile: "mobile",
    desktop: "desktop",
    tablet: "tablet"
};
